export default __webpack_public_path__ + "static/media/background.b70bdbe5.png";